export default __webpack_public_path__ + "static/media/Frozen-18.a00aaa62.svg";